/* eslint-disable react/display-name */
import { i18nPrefix } from './performance-i18n'

const performanceWidgetEn = Object.entries({
    'Link to dashboard': 'Link to dashboard',
    Consistency: 'Consistency',
    RPI: 'RPI',
    'Potential savings': 'Potential savings',
    'Operation time': 'Operation time',
    'Goals planned': 'Goals planned',
    'KPIs measured': 'KPIs measured',
    'Total intervention time': 'Total intervention time',
    'KPI total time': 'KPI total time',
    Rig: 'Rig',
    Rigs: 'Rigs',
    'Rigs association': 'Rigs association',
    'Main Table': 'Main Table',
    'Auxiliary Table': 'Auxiliary Table',
    'RCI (Consistency)': 'RCI (Consistency)',
    'RPI (Performance)': 'RPI (Performance)',
    and: 'and',
    'Permission Required': 'Permission Required',
    'To view the chart, you must have one of the following permissions: Admin or Manage Pipe Widgets.':
        'To view the chart, you must have one of the following permissions: Admin or Manage Pipe Widgets.'
}).reduce(
    (acc, [key, value]) => ({
        ...acc,
        [`${i18nPrefix}${key}`]: value
    }),
    {}
)

export const enUs = {
    values: {
        'Loading...': 'Loading...',
        'No data found': 'No data found',
        'No data in this range': 'No data in this range',
        'KPI Configuration': 'KPI Configuration',
        drilling: 'drilling',
        tripping: 'tripping In/Out',
        casing: 'casing',
        'Shifts Configuration': 'Shifts Configuration',
        Color: 'Color',
        'Start.': 'Start',
        End: 'End',
        'Are you sure you want to discard all changes': 'Are you sure you want to discard all changes',
        'Are you sure you want to save all changes': 'Are you sure you want to save all changes',
        SAVE: 'SAVE',
        DISCARD: 'DISCARD',
        NAME: 'NAME',
        Author: 'Author',
        UNIT: 'UNIT',
        VALUE: 'VALUE',
        'MIN VALUE': 'MIN VALUE',
        TARGET: 'TARGET',
        'MAX VALUE': 'MAX VALUE',
        'CASED HOLE': 'CASED HOLE',
        'OPEN HOLE': 'OPEN HOLE',
        'Last Saved': 'Last Saved',
        'Expand Table': 'Expand Table',
        'discard changes': 'discard changes',
        'No changes to discard': 'No changes to discard',
        'No changes to save': 'No changes to save',
        'Save changes': 'Save changes',
        'GLOBAL CONFIG': 'GLOBAL CONFIG',
        'ADD NEW SHIFT': 'ADD NEW SHIFT',
        'Default Shifts': 'Default Shifts',
        'Please check': 'Please check',
        'Shift with the same color': 'Shift with the same color',
        'Overlaping time': 'Overlaping time',
        'minutes unaccounted for': 'minutes unaccounted for',
        'Fields with empty values': 'Fields with empty values',
        'Something went wrong': 'Something went wrong',
        Shift: 'Shift',
        SHIFTS: 'SHIFTS',
        'KPI PARAMETERS': 'KPI PARAMETERS',
        'GENERAL SETTINGS': 'GENERAL SETTINGS',
        'DRILLING KPIs': 'DRILLING KPIs',
        'CASING KPIs': 'CASING KPIs',
        'TRIPPING KPIs': 'TRIPPING KPIs',
        'Block Weight': 'Block Weight',

        // New
        'Multi KPIs Chart': 'Multi KPIs Chart',
        'Apply Filters': 'Apply Filters',
        Apply: 'Apply',
        Cancel: 'Cancel',
        Close: 'Close',
        Reset: 'Reset',
        Histogram: 'Histogram',
        'User favorites': 'User favorites',
        'A curve that represents the cumulative frequency distribution of grouped data on a graph.':
            'A curve that represents the cumulative frequency distribution of grouped data on a graph.',
        'Cumulative Distribution Curve': 'Cumulative Distribution Curve',
        'Visualization Options': 'Visualization Options',
        'Number of Bins': 'Number of Bins',
        'Max Value': 'Max Value',
        'Min Value': 'Min Value',
        'Max value cannot be less than Min value.': 'Max value cannot be less than Min value.',
        'Min value cannot be greater than Max value.': 'Min value cannot be greater than Max value.',
        Thresholds: 'Thresholds',
        Start: 'Start',
        'Type to search': 'Type to search',
        ' items selected of ': ' items selected of ',
        'Attention, when clicking on the previous button, all the filling of this Tubular will be erased.':
            'Attention, when clicking on the previous button, all the filling of this Tubular will be erased.',
        Previous: 'Previous',
        Finish: 'Finish',
        Timespan: 'Timespan',
        Intervention: 'Intervention',
        RUN_KEY: 'run',
        ACTIVITY_KEY: 'tubular type / activity',
        Rigs: 'Rigs',
        Wells: 'Wells',
        'Start with': 'Start with',
        'Add percentile mark': 'Add percentile mark',
        Period: 'Period',
        'Select a KPI': 'Select a KPI',
        'Select a rig': 'Select a rig',
        'Select a Well': 'Select a Well',
        'All rigs selected': 'All rigs selected',
        'All wells selected': 'All wells selected',
        'The selected Well has been deleted from the Live Wells list. As a result, the RPI per Well stops working, however, this does not affect the RPI per Rig, which continues to work. To solve this problem, simply select another Well in the select options.':
            'The selected Well has been deleted from the Live Wells list. As a result, the RPI per Well stops working, however, this does not affect the RPI per Rig, which continues to work. To solve this problem, simply select another Well in the select options.',
        Type: 'Type',
        'Water Depth': 'Water Depth',
        'Geodetic Reference System': 'Geodetic Reference System',
        'Intervention Tatic': 'Intervention Tatic',
        Responsible: 'Responsible',
        'Accountable name': 'Accountable name',
        Riser: 'Riser',
        'No Previous Casing': 'No Previous Casing',
        'Prev Casing OD': 'Prev Casing OD',
        'Prev Casing Final MD': 'Prev Casing Final MD',
        'RPI Path Status': 'RPI Path Status',
        'Run Number': 'Run Number',
        'Start Date': 'Start Date',
        'End Date': 'End Date',
        'Start Hour': 'Start Hour',
        'End Hour': 'End Hour',
        'Start MD': 'Start MD',
        'Final MD': 'Final MD',
        'Run Final MD': 'Run Final MD',
        'Select type': 'Select type',
        'Tubulars interval per time': 'Tubulars interval per time',
        'Cemented Plug Present': 'Cemented Plug Present',
        'Delete this Cement Start MD and Cement Final MD': 'Delete this Cement Start MD and Cement Final MD',
        'Add New Cemented Plug': 'Add New Cemented Plug',
        'Run Workstring Current Status': 'Run Workstring Current Status',
        NUMBER: 'NUMBER',
        INTERVAL: 'INTERVAL',
        PREVIOUS: 'PREVIOUS',
        TIME: 'Time',
        DEPTH: 'Depth',
        'Increases the length of the last tubular if the final bit depth in the current run is greater than expected.':
            'Increases the length of the last tubular if the final bit depth in the current run is greater than expected.',
        'Tubular Type': 'Tubular Type',
        'Tubular Connection Type': 'Tubular Connection Type',
        'Third Party Responsible': 'Third Party Responsible',
        'Permanent Tubular Installation': 'Permanent Tubular Installation',
        'You must fill this field with a value less than the OD value from the previous section.':
            'You must fill this field with a value less than the OD value from the previous section.',
        'You must fill this field with a value less than the Final MD value from the previous section.':
            'You must fill this field with a value less than the Final MD value from the previous section.',
        'The value of this field is automatically filled in corresponding to the sum of the value of the previous run (Number of the previous run +1) in the same section, obeying the increasing sequence of runs. For example, if the previous run was run 4, the value of this field would be 5, and so on.':
            'The value of this field is automatically filled in corresponding to the sum of the value of the previous run (Number of the previous run +1) in the same section, obeying the increasing sequence of runs. For example, if the previous run was run 4, the value of this field would be 5, and so on.',
        'You must fill this field with a value greater than the MD Final value from the previous run. Fill this field with a value greater than the MD Final value from the previous run.':
            'You must fill this field with a value greater than the MD Final value from the previous run. Fill this field with a value greater than the MD Final value from the previous run.',
        'You must fill this field with a value less than or equal to Section Final MD and greater than Run Start MD.':
            'You must fill this field with a value less than or equal to Section Final MD and greater than Run Start MD.',
        'For insertion of tubulars by time, enable the checkbox. The default behavior is the insertion of tubulars by  Depth (checkbox disabled). Once the Run is started,  the tubulars in the workstring must be configured with the tubular interval type defined here.':
            'For insertion of tubulars by time, enable the checkbox. The default behavior is the insertion of tubulars by  Depth (checkbox disabled). Once the Run is started,  the tubulars in the workstring must be configured with the tubular interval type defined here.',
        'When enabled, the KPIs of this Run will be classified as Cemented Plug Present, for Stand Type Inclusion (trip in) only. The Cement Start MD and Cement Final MD fields will be enabled for entering numerical values contained between the Run Start MD and Run Final MD values.':
            'When enabled, the KPIs of this Run will be classified as Cemented Plug Present, for Stand Type Inclusion (trip in) only. The Cement Start MD and Cement Final MD fields will be enabled for entering numerical values contained between the Run Start MD and Run Final MD values.',
        'This checkbox enabled defines that the last tubular will have its depth extended to the greatest bit depth until run end time, allowing the automatic adjustment of the tubular Final MD. If disabled, there will be no classification of the tubular from the maximum bit depth after tubular and run Final MD.':
            'This checkbox enabled defines that the last tubular will have its depth extended to the greatest bit depth until run end time, allowing the automatic adjustment of the tubular Final MD. If disabled, there will be no classification of the tubular from the maximum bit depth after tubular and run Final MD.',
        'Connection types for Screen, Tubing and Casing tubes. The other tubulars will not consider the possibility of connection type and default to the option Not applicable.':
            'Connection types for Screen, Tubing and Casing tubes. The other tubulars will not consider the possibility of connection type and default to the option Not applicable.',
        'By checking this box, you are informing that the tubular will be installed in the well permanently and that it will not return to the surface.':
            'By checking this box, you are informing that the tubular will be installed in the well permanently and that it will not return to the surface.',
        'You must fill this field with a value less than the Section OD value when the Tubular Type is Casing.':
            'You must fill this field with a value less than the Section OD value when the Tubular Type is Casing.',
        'This field is automatically filled with the Final MD from the previous tubular.':
            'This field is automatically filled with the Final MD from the previous tubular.',
        'You must fill this field with a value less than or equal to the Run Final MD value.':
            'You must fill this field with a value less than or equal to the Run Final MD value.',
        Rig: 'Rig',
        Well: 'Well',
        'All timespan selected': 'All timespan selected',
        'One or more fields have an error. Please check and try again.':
            'One or more fields have an error. Please check and try again.',
        'Invalid Time Span': 'Invalid Time Span',
        'Marks on the graph a target mark that allows visualizing and comparing the proximity of the data distribution with the desired target value.':
            'Marks on the graph a target mark that allows visualizing and comparing the proximity of the data distribution with the desired target value.',
        'Displays a curve that describes the frequency distribution of a KPI.':
            'Displays a curve that describes the frequency distribution of a KPI.',
        items: 'items',
        'Click to add': 'Click to add',
        Position: 'Position',
        Attributes: 'Attributes',
        'All intervention selected': 'All intervention selected',
        'Data & Filters': 'Data & Filters',
        'Chart Settings': 'Chart Settings',
        Settings: 'Settings',
        Templates: 'Templates',
        TEMPLATES: 'TEMPLATES',
        Template: 'Template',
        'items selected of': 'items selected of',
        FREQUENCY: 'FREQUENCY',
        CUMULATIVE: 'CUMULATIVE',
        'Type to search...': 'Type to search...',
        Presets: 'Presets',
        'Field is missing, please check and try again.': 'Field is missing, please check and try again.',
        'The amount of data periods that will be analyzed.': 'The amount of data periods that will be analyzed.',
        'All time': 'All time',
        'Last day': 'Last day',
        'Last week': 'Last week',
        'Last 15 days': 'Last 15 days',
        'Last month': 'Last month',
        'Last quarter': 'Last quarter',
        'Last semester': 'Last semester',
        'Last year': 'Last year',
        'Standard Deviation': 'Standard Deviation',
        'Add New Template': 'Add New Template',
        'Template name...': 'Template name...',
        'Save template with current config': 'Save template with current config',
        'Save Template': 'Save Template',
        'Cancel changes': 'Cancel changes',
        'Apply Template': 'Apply Template',
        'Edit Template': 'Edit Template',
        'Delete Template': 'Delete Template',
        Edit: 'Edit',
        'KPI/Channel': 'KPI/Channel',
        'No intervetions selected': 'No intervetions selected',
        'All Timespan selected': 'All timespan selected',
        'Select a chart type...': 'Select a chart type...',
        'Save this widget and return to the dashboard.': 'Save this widget and return to the dashboard.',
        'Filters and settings are displayed in visualization mode only.':
            'Filters and settings are displayed in visualization mode only.',
        Cumulative: 'Cumulative',
        'Select a KPI/Channel': 'Select a KPI/Channel',
        EVENTS: 'EVENTS',
        'Potential Savings': 'Potential Savings',
        'TARGET(MEDIAN)': 'TARGET(MEDIAN)',
        'POTENTIAL SAVINGS': 'POTENTIAL SAVINGS',
        'BELOW TARGET': 'BELOW TARGET',
        'ABOVE TARGET': 'ABOVE TARGET',
        'TOTAL SAVED': 'TOTAL SAVED',
        TOTAL: 'TOTAL',
        Median: 'Median',
        'Target must be greater than zero': 'Target must be greater than zero.',
        'The current configuration does not match the original configuration of this Template. Click the Save Current Config button to update the template or the Add New Template button to create a new template from the current configuration.':
            'The current configuration does not match the original configuration of this Template. Click the Save Current Config button to update the template or the Add New Template button to create a new template from the current configuration.',
        'You must fill the Template name.': 'You must fill the Template name.',
        'This name has already been defined in another Template. Please, choose another name.':
            'This name has already been defined in another Template. Please, choose another name.',
        'Template was applied successfully': 'Template was applied successfully',
        The: 'The',
        'config was applied to generate the histogram.': 'config was applied to generate the histogram.',
        'The histogram was successfully generated with the current config':
            'The histogram was successfully generated with the current config',

        // New
        'Annotation Tool': 'Annotation Tool',
        'Review Options': 'Review Options',
        'Review Option': 'Review Option',
        'Select period': 'Select period',
        'Select asset': 'Select asset',
        'Zoom option: every': 'Zoom option: every',
        'Zoom In': 'Zoom In',
        'Zoom Out': 'Zoom Out',
        'Reset Zoom': 'Reset Zoom',
        Options: 'Options',
        'View Kpis': 'View Kpis',
        'Select method...': 'Select method...',
        'Select method': 'Select method',
        'Sequential Time Review': 'Sequential Time Review',
        'Cutoff Filters (Min, Max, Relative Deviation)': 'Cutoff Filters (Min, Max, Relative Deviation)',
        'Zoom Settings': 'Zoom Settings',
        'Every 15 minutes': 'Every 15 minutes',
        'Every 30 minutes': 'Every 30 minutes',
        'Every Hour': 'Every Hour',
        'Every Two Hours': 'Every Two Hours',
        'Every KPIs': 'Every KPIs',
        'Every 2 KPIs': 'Every 2 KPIs',
        'Every 3 KPIs': 'Every 3 KPIs',
        'Every 5 KPIs': 'Every 5 KPIs',
        'Below Min': 'Below Min',
        'Above Max': 'Above Max',
        Deviation: 'Deviation',
        'TOOLTIP COLOR': 'TOOLTIP COLOR',
        'CHANNEL OPTIONS': 'CHANNEL OPTIONS',
        'KPIS REVIEW PANE': 'KPIS REVIEW PANE',
        'See kpis': 'See kpis',

        'Degree of dispersion of a data set. Indicates how uniform a data set is. The closer to zero the standard deviation, the more homogeneous the data are.':
            'Degree of dispersion of a data set. Indicates how uniform a data set is. The closer to zero the standard deviation, the more homogeneous the data are.',
        'Shows the time sums above and below the target (if there is no target, consider the median). The difference between these values is the total time saved, if greater than zero, or wasted, otherwise.':
            'Shows the time sums above and below the target (if there is no target, consider the median). The difference between these values is the total time saved, if greater than zero, or wasted, otherwise.',
        'Changes applied with success': 'Changes applied with success',
        'Template applied.': 'Template applied.',
        'Current config saved on Template.': 'Current config saved on Template.',
        'For some reason, no shift information was returned. Check your connection and try again later.':
            'For some reason, no shift information was returned. Check your connection and try again later.',
        "For some reason, your request couldn't be saved": "For some reason, your request couldn't be saved",
        'It is not possible to add more than 6 shifts.': 'It is not possible to add more than 6 shifts.',
        'At least one shift has to be configured.': 'At least one shift has to be configured.',
        'Algorithm Thresholds': 'Algorithm Thresholds',
        'Target Settings': 'Target Settings',
        'Value must be bigger than zero': 'Value must be bigger than zero',
        'Value smaller than or equal to min value': 'Value smaller than or equal to min value',
        'Value smaller than or equal to target value': 'Value smaller than or equal to target value',
        'Value larger than or equal to target value': 'Value larger than or equal to target value',
        'Value larger than or equal to max value': 'Value larger than or equal to max value',
        'is a system pattern that can be overriden in each rig parameters.':
            'is a system pattern that can be overriden in each rig parameters.',
        'Default operation shifts should be applied to all active rigs, unless there is a different profile defined here in this section.':
            'Default operation shifts should be applied to all active rigs, unless there is a different profile defined here in this section.',
        'Values set here will affect rig values with overriden parameters which can be accessed on each rig option on the “Operational Targets” tab.':
            'Values set here will affect rig values with overriden parameters which can be accessed on each rig option on the “Operational Targets” tab.',
        "Use this page to configure how crew's shifts should be assingned. The shifts should each have a diferent color and a different time span. No shift can overlap with another. You can configure between 1 and 6 shifts.":
            "Use this page to configure how crew's shifts should be assingned. The shifts should each have a diferent color and a different time span. No shift can overlap with another. You can configure between 1 and 6 shifts.",
        'This time represents the time spent since the operator turns off the pumps until the moment the pump brings the flow again. Actually it is the time without flow rate.':
            'This time represents the time spent since the operator turns off the pumps until the moment the pump brings the flow again. Actually it is the time without flow rate.',
        'This is the time spent in slips and making a connection during tripping operations.':
            'This is the time spent in slips and making a connection during tripping operations.',
        'The Pipe Moving Time represents the time needed for running one stand of drill pipe in or out of the hole. Actually it is the time between two slip to slip connections.':
            'The Pipe Moving Time represents the time needed for running one stand of drill pipe in or out of the hole. Actually it is the time between two slip to slip connections.',
        'This is the average speed the pipe is tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'This is the average speed the pipe is tripped in or out of the hole as a combination of pipe moving time and in slips time.',
        'The Gross Time per Stand KPI represents the time needed for the pipe to be tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'The Gross Time per Stand KPI represents the time needed for the pipe to be tripped in or out of the hole as a combination of pipe moving time and in slips time.',
        'This is the time spent in slips during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'This is the time spent in slips during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.',
        'This is the average speed the joint is moved during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'This is the average speed the joint is moved during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.',
        'This KPI represents the time needed for running one joint of casing/liner into the cased hole. Actually it is the time between two casing/liner slip to slip connections.':
            'This KPI represents the time needed for running one joint of casing/liner into the cased hole. Actually it is the time between two casing/liner slip to slip connections.',
        'The KPI Gross Time per Stand represents the time needed for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'The KPI Gross Time per Stand represents the time needed for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time.',
        'This is the average speed the joint is run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'This is the average speed the joint is run in the cased hole or open hole as a combination of pipe moving time and in slips time.',
        'This is the rate for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time. Actually it is the Casing – Gross Running Speed divided by an average casing joint length.':
            'This is the rate for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time. Actually it is the Casing – Gross Running Speed divided by an average casing joint length.',
        'Weight to Weight Minimum Flow': 'Weight to Weight Minimum Flow',
        'Weight to Weight Minimum Flow Duration': 'Weight to Weight Minimum Flow Duration',
        'Weight to Weight Off Bottom Threshold': 'Weight to Weight Off Bottom Threshold',
        'Weight to Weight On Bottom Threshold': 'Weight to Weight On Bottom Threshold',
        'Weight to Weight Minimum BPOS': 'Weight to Weight Minimum BPOS',
        'Slip to Slip Minimum HKLD': 'Slip to Slip Minimum HKLD',
        'Slip to Slip Maximum Flow': 'Slip to Slip Maximum Flow',
        'Pump to Pump time': 'Pump to Pump time',
        'Weight to Weight Time': 'Weight to Weight Time',
        'Weight to Slip Time': 'Weight to Slip Time',
        'Slip to Slip Connection Time': 'Slip to Slip Connection Time',
        'Slip to Weight Time': 'Slip to Weight Time',
        'Gross Time per Stand': 'Gross Time per Stand',
        'Gross Drilling ROP per Stand': 'Gross Drilling ROP per Stand',
        'Rotating Drilling Time per Stand': 'Rotating Drilling Time per Stand',
        'Rotating Drilling Meterage per Stand': 'Rotating Drilling Meterage per Stand',
        'Rotating Drilling ROP per Stand': 'Rotating Drilling ROP per Stand',
        'Sliding Drilling Time per Stand': 'Sliding Drilling Time per Stand',
        'Sliding Drilling Meterage per Stand': 'Sliding Drilling Meterage per Stand',
        'Sliding Drilling ROP per Stand': 'Sliding Drilling ROP per Stand',
        'Average Pipe Moving Speed': 'Average Pipe Moving Speed',
        'Pipe Moving Time': 'Pipe Moving Time',
        'Gross Running Speed': 'Gross Running Speed',
        'Gross Running Rate': 'Gross Running Rate',
        'This is the time spent in slips and making a connection during drilling operations:':
            'This is the time spent in slips and making a connection during drilling operations:',
        'A Weight to Weight Connection represents the time between two drilled stands. This KPI starts when the drill string is lifted off from bottom and lasts until the string is on bottom drilling again':
            'A Weight to Weight Connection represents the time between two drilled stands. This KPI starts when the drill string is lifted off from bottom and lasts until the string is on bottom drilling again',
        'The Weight to Slips Time KPI is only calculated during a weight to weight connection. This KPI starts when the bit is lifted off bottom and lasts until the drill string is in slips':
            'The Weight to Slips Time KPI is only calculated during a weight to weight connection. This KPI starts when the bit is lifted off bottom and lasts until the drill string is in slips',
        'The Slips to Weight Time KPI is only calculated during a weight to weight connection. This KPI starts when the drill string is released out of the slips and lasts until the bit is on bottom drilling again.':
            'The Slips to Weight Time KPI is only calculated during a weight to weight connection. This KPI starts when the drill string is released out of the slips and lasts until the bit is on bottom drilling again.',
        'This is the time spent since the pump has been turned off until the pumps come with flow again.':
            'This is the time spent since the pump has been turned off until the pumps come with flow again.',
        'This is the total time needed for drilling one stand of pipe including the weight to weight connection. Actually it covers all time from the end of a weight to weight connection until the end of the subsequent one':
            'This is the total time needed for drilling one stand of pipe including the weight to weight connection. Actually it covers all time from the end of a weight to weight connection until the end of the subsequent one',
        'This KPI is calculated by dividing the drilled distance for one stand of pipe with the Drilling Gross Time KPI.':
            'This KPI is calculated by dividing the drilled distance for one stand of pipe with the Drilling Gross Time KPI.',
        'The Rotating Drilling Time for one stand of pipe represents the time drilling in rotary mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g.wellbore conditioning, toolface orientation, weight to weight connections, etc.).':
            'The Rotating Drilling Time for one stand of pipe represents the time drilling in rotary mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g.wellbore conditioning, toolface orientation, weight to weight connections, etc.).',
        'This is the distance per stand that was drilled in rotary mode.':
            'This is the distance per stand that was drilled in rotary mode.',
        'This is the ROP per stand that was drilled in sliding mode. Actually it is calculated by dividing the Sliding Drilling Meterage with the Sliding Drilling Time.':
            'This is the ROP per stand that was drilled in sliding mode. Actually it is calculated by dividing the Sliding Drilling Meterage with the Sliding Drilling Time.',
        'The Sliding Drilling Time for one stand of pipe represents the time drilling in sliding mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.)':
            'The Sliding Drilling Time for one stand of pipe represents the time drilling in sliding mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.)',
        'This is the distance per stand that was drilled in sliding mode.':
            'This is the distance per stand that was drilled in sliding mode.',
        'This is the minimum time with pump off without weight on bit.':
            'This is the minimum time with pump off without weight on bit.',
        'This is the minimum distance from the bit to the bottom, to consider that drilling has started or resumed.':
            'This is the minimum distance from the bit to the bottom, to consider that drilling has started or resumed.',
        'This is the maximum distance from the bit to the bottom to consider that it is not drilling.':
            'This is the maximum distance from the bit to the bottom to consider that it is not drilling.',
        'This is the minimum height of the block in relation to the rotary table, to consider that it is not drilling.':
            'This is the minimum height of the block in relation to the rotary table, to consider that it is not drilling.',
        'This is the maximum residual value during connection.':
            'This is the maximum residual value during connection.',
        Clear: 'Clear',
        BROKEN_RULE_1:
            "W2W and P2P aren´t Tripping type KPIs! It's not possible to create a Drilling KPI on this Tripping stand!",
        BROKEN_RULE_2:
            "Tripping in and Tripping Out aren't Drilling type KPIs! It's not possible to create a Tripping KPI on this Drilling stand!",
        BROKEN_RULE_3: "S2S, ROP and Tripping IN/OUT can't occur in multiple Stands!",
        BROKEN_RULE_4: 'W2W and P2P always occurs between exactly two consecutive Stands!',
        BROKEN_RULE_5: "Can't exists multiple occurrences of the same KPI in a unique Stand!",
        BROKEN_RULE_6: "S2S, ROP and TRIPPING IN/OUT can't overlap each others!",
        BROKEN_RULE_7: 'All KPI annotations needs a Stand ID!',
        BROKEN_RULE_8: "Tripping IN KPI can't be created on tripping out (removal) stand!",
        BROKEN_RULE_9: "Tripping OUT KPI can't be created on tripping in (inclusion) stand!",
        INVALID_TRIPPING_DISQUALIFIED: 'Invalid tripping KPI, disqualified event',
        ROP_KPI_MUST_BE_INSIDE_DRILLING_STAND: 'ROP KPI must be inside a drilling stand',
        STAND_TYPE_EMPTY: 'Stand type empty',
        REAL_TIME_AGGREGATION_WARNING:
            'The real time data compression is turned off. No new compressed data is being generated.',
        'Restricted Performance': 'Restricted Performance',
        'No Restricted Performance': 'No Restricted Performance',
        'All Restricted Performance fields need to be filled in to be able to close the modal. Fill in all fields or delete the Restricted Performance being filled.':
            'All Restricted Performance fields need to be filled in to be able to close the modal. Fill in all fields or delete the Restricted Performance being filled.',
        'Realtime Rig State Channels Configuration': 'Realtime Rig State Channels Configuration',
        'Rate of Penetration': 'Rate of Penetration',
        'Block Position': 'Block Position',
        'Weight on Bit': 'Weight on Bit',
        'SPP Pressure': 'SPP Pressure',
        'Surface Torque': 'Surface Torque',
        'Mud Flow In': 'Mud Flow In',
        Hookload: 'Hookload',
        'Surface RPM': 'Surface RPM',
        'Rig State Channels for Reprocessing': 'Rig State Channels for Reprocessing',
        'KPI GOALS': 'KPI GOALS',
        'New KPI Goal': 'New KPI Goal',
        'Macro Operation': 'Macro Operation',
        'Tubular-Activities': 'Tubular-Activities',
        'Stand Size': 'Stand Size',
        'Stand Type': 'Stand Type',
        'Tubular OD': 'Tubular OD',
        'Movement Direction': 'Movement Direction',
        'Section Hole Status': 'Section Hole Status',
        'Restricted Performance': 'Restricted Performance',
        goals: 'goals',
        maxCutOff: 'max cut off',
        minCutOff: 'min cut off',
        rigReferenceValue: 'rig reference value',
        Drilling: 'Drilling',
        Tripping: 'Tripping',
        'If you turn this feature on, you will be able to create a Total Stand Time goal and it will be applied as a performance indicator in the Rigs where it is assigned.':
            'If you turn this feature on, you will be able to create a Total Stand Time goal and it will be applied as a performance indicator in the Rigs where it is assigned.',
        'Total Stand Time KPI': 'Total Stand Time KPI',
        'tst-off': 'off',
        'tst-on': 'on',
        'This feature allows you to create a Total Stand Time goal. To turn this feature on or off, go to KPI Configuration, choose KPI Goals Settings and the Tripping operation macro.':
            'This feature allows you to create a Total Stand Time goal. To turn this feature on or off, go to KPI Configuration, choose KPI Goals Settings and the Tripping operation macro.',
        'Total Stand Time is now an indicator': 'Total Stand Time is now an indicator',
        'When turn on this feature, the Total Stand Time goal will be applied as an indicator in the rigs. This action can be reversed.':
            'When turn on this feature, the Total Stand Time goal will be applied as an indicator in the rigs. This action can be reversed.',
        'Are you sure you want to discard all changes? By changing the tab all your goal values will be lost':
            'Are you sure you want to discard all changes? By changing the tab all your goal values will be lost',
        'Search KPI Goal': 'Search KPI Goal',
        'Goals saved successfully.': 'Goals saved successfully.',
        'Goals updated successfully.': 'Goals updated successfully.',
        'Goals deleted successfully.': 'Goals deleted successfully.',
        'Are you sure you want delete this goal?': 'Are you sure you want delete this goal?',
        'Showing all': 'Showing all',
        'ADD KPI GOAL': 'ADD KPI GOAL',
        'Swap KPI Goals': 'Swap KPI Goals',
        "You don't have permission to create an event. Please contact your system administrator.":
            "You don't have permission to create an event. Please contact your system administrator.",
        "You don't have permission to view this dashboard. Please contact your system administrator.":
            "You don't have permission to view this dashboard. Please contact your system administrator.",
        'Customize Rig State Channels for Reprocessing': 'Customize Rig State Channels for Reprocessing',
        'Real time': 'Real time',
        'KPI SERVICE': 'KPI SERVICE',
        'Macro Operation': 'Macro Operation',
        History: 'History',
        'SELECTED CHANNELS': 'SELECTED CHANNELS',
        'KPI Channels': 'KPI Channels',
        'Select KPI channel': 'Select KPI channel',
        'Add channel': 'Add channel',
        'Restore Chart Defaults': 'Restore Chart Defaults',
        Color: 'Color',
        'Custom color': 'Custom color',
        "Couldn't get data on period": "Don't have any channels data on this period.",
        Unrestricted: 'Unrestricted',
        Restricted: 'Restricted',
        'Delete only the last tubular.': 'Delete only the last tubular.',
        'Delete the tubular set (Run Workstring).': 'Delete the tubular set (Run Workstring).',
        'Are you sure you want to delete?': 'Are you sure you want to delete?',
        'All child events will be deleted along with this one.':
            'All child events will be deleted along with this one.',
        'This action cannot be undone.': 'This action cannot be undone.',
        'This value is greater than to the Run Final MD': 'This value is greater than to the Run Final MD',
        'Tubular type option is required for goals to appear': 'Tubular type option is required for goals to appear',
        'Editing or creating KPI goals will modify the performance calculation in Platform Performance Index dashboards.':
            'Editing or creating KPI goals will modify the performance calculation in Platform Performance Index dashboards.',
        'Are you sure you want to complete this action?': 'Are you sure you want to complete this action?',
        // Well Operations Navigation
        INTERVENTION: 'INTERVENTION',
        'SECTION/PHASE': 'SECTION/PHASE',
        RUN: 'RUN',
        'Intervention name': 'Intervention name',
        'Section OD': 'Section OD',
        'Run Number': 'Run Number',
        'Run Type': 'Run Type',
        'Section not started': 'Section not started',
        'Run not started': 'Run not started',
        'No Static Data found in the selected period': 'No Static Data found in the selected period',
        // Pipe
        'Pipe Movement': 'Pipe Movement',
        'Restricted Pipe Movement: ': 'Restricted Pipe Movement: ',
        'Restricted Pipe Movement Type': 'Restricted Pipe Movement Type',
        'Restricted Movement Goal': 'Restricted Movement Goal',
        'Add Restricted Pipe Movement': 'Add Restricted Pipe Movement',
        'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted Pipe Movement Type Final MD.':
            'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted Pipe Movement Type Final MD.',
        'This field is automatically filled with values defined in KPI Goals of the Rig.':
            'This field is automatically filled with values defined in KPI Goals of the Rig.',
        'There is no KPI Goal applied for this Restricted Performance. You must set a value by going to Rigs > Selected Rig > KPI Options > KPI Goals (Access KPI Goals). In the KPI Goals list, select Tubular/Activities > KPI > Pipe Moving Time and Restricted Performance > Restricted.  Set a value in the KPI Goal field. When the goal is saved, the assigned value will be automatically loaded and filled in the Restricted Movement Goal field.':
            'There is no KPI Goal applied for this Restricted Performance. You must set a value by going to Rigs > Selected Rig > KPI Options > KPI Goals (Access KPI Goals). In the KPI Goals list, select Tubular/Activities > KPI > Pipe Moving Time and Restricted Performance > Restricted.  Set a value in the KPI Goal field. When the goal is saved, the assigned value will be automatically loaded and filled in the Restricted Movement Goal field.',
        'Pipe MovementKey': 'Pipe Movement',
        // Connection Type
        'Connection Type': 'Connection Type',
        'Restricted Connection: ': 'Restricted Connection: ',
        'Restriction Type': 'Restriction Type',
        'Restricted Connection Goal': 'Restricted Connection Goal',
        'Add Restricted Connection': 'Add Restricted Connection',
        'Click to more information': 'Click to more information',
        'Missing information': 'Missing information',
        'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted Pipe Movement Type Final MD.':
            'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted Pipe Movement Type Final MD.',
        'You must fill this field with a value less than or equal to the Run Final MD value and greater than the Start MD.':
            'You must fill this field with a value less than or equal to the Run Final MD value and greater than the Start MD.',
        "You must fill this field with a value greater than or equal to the tubular's Start Date/Hour value (when it is the first Restricted Performance) or greater than the End Date/Hour of the previous Restricted Performance.This checkbox enabled defines that the first tubular will have its depth extended to the greatest bit depth, allowing the automatic adjustment of the Final MD to the same value of Run Final MD. If disabled, there will be no classification of the tubular from the maximum bit depth.":
            "You must fill this field with a value greater than or equal to the tubular's Start Date/Hour value (when it is the first Restricted Performance) or greater than the End Date/Hour of the previous Restricted Performance.This checkbox enabled defines that the first tubular will have its depth extended to the greatest bit depth, allowing the automatic adjustment of the Final MD to the same value of Run Final MD. If disabled, there will be no classification of the tubular from the maximum bit depth.",
        'This field is automatically filled with the End Date/Hour from the previous tubular':
            'This field is automatically filled with the End Date/Hour from the previous tubular',
        'There is no KPI Goal applied for this Restricted Performance. You must set a value by going to Rigs > Selected Rig > KPI Options > KPI Goals (Access KPI Goals). In the KPI Goals list, select Tubular/Activities > KPI > Slip to Slip and Restricted Performance > Wet Pipe Tripping or Drifting or Restricted.  Set a value in the KPI Goal field. When the goal is saved, the assigned value will be automatically loaded and filled in the Restricted Connection Goal field field.':
            'There is no KPI Goal applied for this Restricted Performance. You must set a value by going to Rigs > Selected Rig > KPI Options > KPI Goals (Access KPI Goals). In the KPI Goals list, select Tubular/Activities > KPI > Slip to Slip and Restricted Performance > Wet Pipe Tripping or Drifting or Restricted.  Set a value in the KPI Goal field. When the goal is saved, the assigned value will be automatically loaded and filled in the Restricted Connection Goal field field.',
        ConnectionKey: 'Connection',
        // RESTRICTED RATE OF PENETRATION
        'Restricted Rate of Penetration: ': 'Restricted Rate of Penetration: ',
        'Restricted ROP': 'Restricted ROP',
        'Restricted ROP Goal': 'Restricted ROP Goal',
        'Add Restricted Rate of Penetration': 'Add Restricted Rate of Penetration',
        'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted ROP Final MD.':
            'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted ROP Final MD.',
        'You must fill this field with a value less than or equal to the Run Final MD value and greater than the Start MD.':
            'You must fill this field with a value less than or equal to the Run Final MD value and greater than the Start MD.',
        'There is no KPI Goal applied for this Restricted Performance. You must set a value by going to Rigs > Selected Rig > KPI Options > KPI Goals (Access KPI Goals). In the KPI Goals list, select Tubular/Activities > KPI > ROP per Stand and Restricted Performance > Restricted.  Set a value in the KPI Goal field. When the goal is saved, the assigned value will be automatically loaded and filled in the Restricted ROP Goal field.':
            'There is no KPI Goal applied for this Restricted Performance. You must set a value by going to Rigs > Selected Rig > KPI Options > KPI Goals (Access KPI Goals). In the KPI Goals list, select Tubular/Activities > KPI > ROP per Stand and Restricted Performance > Restricted.  Set a value in the KPI Goal field. When the goal is saved, the assigned value will be automatically loaded and filled in the Restricted ROP Goal field.',
        'Please Select a Rig on Asset Filter': 'Please Select a Rig on Asset Filter',
        'An asset selected on filter is necessary': 'An asset selected on filter is necessary',
        'This field is automatically filled with the KPI Goal value of the KPI ROP per Stand in KPI Goals of the Rig.':
            'This field is automatically filled with the KPI Goal value of the KPI ROP per Stand in KPI Goals of the Rig.',
        'This field is filled with values defined in KPI Goals of the Rig. Only values referring to the selected unit are given as options. For values in another unit, select the corresponding unit.':
            'This field is filled with values defined in KPI Goals of the Rig. Only values referring to the selected unit are given as options. For values in another unit, select the corresponding unit.',
        // API MESSAGES
        'Entity created successfully.': 'Entity created successfully.',
        'Entity tubulartype by depth created successfully.': 'Entity tubular type by depth created successfully.',
        'Unable to create entity tubulartype by depth:': 'Unable to create entity tubular type by depth:',
        unablecreatetubbydepth: 'Unable to create entity tubular type by depth:',
        'Error getting entity options.': 'Error getting entity options.',
        'Unable to fetch unities for type.': 'Unable to fetch unities for type.',
        'Unable to fetch entities for Rig ID': 'Unable to fetch entities for Rig ID',
        'Unable to fetch entities for type.': 'Unable to fetch entities for type.',
        'Error getting start timestamp for entity.': 'Error getting start timestamp for entity.',
        'Error getting end timestamp for entity.': 'Error getting end timestamp for entity.',
        'Unable to fetch entity.': 'Unable to fetch entity.',
        'Entity deleted successfully.': 'Entity deleted successfully.',
        'Unable to delete entity.': 'Unable to delete entity.',
        'Invalid entity creation.': 'Invalid entity creation.',
        'Entity updated successfully.': 'Entity updated successfully.',
        'Unable to fetch assets for rig.': 'Unable to fetch assets for rig.',
        'Unable to fetch live wells.': 'Unable to fetch live wells.',
        'Unable to get rig id from name': 'Unable to get rig id from name',
        'Unable to fetch kpi goals with filter.': 'Unable to fetch kpi goals with filter.',
        'Could not create': 'Could not create',
        'Unable to create entity': 'Unable to create entity',
        // API MESSAGES phaseAPI
        'Error getting previous casing from Tubular Type and Run.':
            'Error getting previous casing from Tubular Type and Run.',
        'Error getting well type of section well.': 'Error getting well type of section well.',
        // API MESSAGES runAPI
        'Error getting Start and Run Number from Run.': 'Error getting Start and Run Number from Run.',
        'Tubulars configuration updated successfully': 'Tubulars configuration updated successfully',
        'Unable to update tubulars configuration: ': 'Unable to update tubulars configuration: ',
        'The run tubulars were successfully deleted': 'The run tubulars were successfully deleted',
        'Unable to delete run tubulars': 'Unable to delete run tubulars',
        // CHART COMPONENT
        'Track disabled': 'Track disabled',
        'You need to start an event on the tospan layer.': 'You need to start an event on the tospan layer.',

        /// // Rig Performance Index Table /////
        'Discarded KPIs': 'Discarded KPIs',
        'Discarded KPIs Table': 'Discarded KPIs Table',
        Duration: 'Duration',
        'Result Log': 'Result Log',
        Acronym: 'Acronym',
        'Operations and KPIs Indicators': 'Operations and KPIs Indicators',
        'Performance Over Time': 'Performance Over Time',
        RIG: 'RIG',
        RPI: 'RPI',
        'Rig Responsible': 'Rig Responsible',
        'Total Operations Time': 'Total Operations Time',
        Well: 'Well',
        timespan: 'timespan',
        'operation type': 'operation type',
        periods: 'periods',
        'operation and kpi': 'operation and kpi',
        rpi: 'rpi',
        'kpi goal': 'kpi goal',
        'kpi quantity': 'kpi quantity',
        planned: 'planned',
        measured: 'measured',
        'RPI Coverage': 'RPI Coverage',
        days: 'days',
        day: 'day',
        hours: 'hours',
        hour: 'hour',
        'potential savings over goal': 'potential savings over goal',
        'ilt over goal': 'ilt over goal',
        'gains over goal': 'gains over goal',
        'Error getting table.': 'Error getting table.',
        'Please, select a Rig on Asset Filter and set a timespan':
            'Please, select a Rig on Asset Filter and set a timespan',
        'Delete Restricted Performance': 'Delete Restricted Performance',
        'No Restriction Applied': 'No Restriction Applied',
        'There is no Restricted Performance defined for this tubular. Click the Add Restricted button to include.':
            'There is no Restricted Performance defined for this tubular. Click the Add Restricted button to include.',
        'Choose date': 'Choose date',
        'This field is automatically filled with the Prev Casing OD from the previous section.':
            'This field is automatically filled with the Prev Casing OD from the previous section.',
        'This field is automatically filled with the Prev Casing Final MD from the previous section.':
            'This field is automatically filled with the Prev Casing Final MD from the previous section.',
        'Please correct the highlighted fields': 'Please correct the highlighted fields',
        'When saved this action cannot be undone.': 'When saved this action cannot be undone.',
        'Are you sure you want to change this?': 'Are you sure you want to change this?',
        'All restrictions will be delected.': 'All restrictions will be delected.',
        'Could not find given Asset': 'Could not find given Asset',
        'Could not find any kpi goals for this timespan': 'Could not find any kpi goals for this timespan',
        'Could not find any static data for this timespan': 'Could not find any static data for this timespan',
        'Could not query static data entities for this timespan':
            'Could not query static data entities for this timespan',
        'Could not get static data entities for this timespan': 'Could not get static data entities for this timespan',
        'Could not find any kpi for this timespan': 'Could not find any kpi for this timespan',
        'Could not find any stand for this timespan': 'Could not find any stand for this timespan',
        'A problem occurred while searching bit depth event for this timespan':
            'A problem occurred while searching bit depth event for this timespan',
        'Could not find any bit depth event for this timespan': 'Could not find any bit depth event for this timespan',
        "Could not find the deepest bit depth event for run's last tubular extension":
            "Could not find the deepest bit depth event for run's last tubular extension",
        'A negative KPI value was found': 'A negative KPI value was found',
        'A negative GOAL value was found': 'A negative GOAL value was found',
        'IDS denominator is equal to zero': 'RPI denominator is equal to zero',
        'No KPI was considered in the calculation': 'No KPI was considered in the calculation',
        'An unhandled problem was found while calculating IDS': 'An unhandled problem was found while calculating RPI',
        'Download result log': 'Download result log',
        'It was not possible to do the download.': 'It was not possible to do the download.',
        'KPI Goal Versions': 'KPI Goal Versions',
        'KPI Goal Versions by Operations': 'KPI Goal Versions by Operations',
        'No goal version to display.': 'No goal version to display.',
        Operation: 'Operation',
        'KPI Goal Version': 'KPI Goal Version',
        'No goal version': 'No goal version',

        // Static Data Import
        'You can import or create static data entries for a well.':
            'You can import or create static data entries for a well.',
        'Import data': 'Import data',
        'Create data': 'Create data',
        'Import Configuration': 'Import Configuration',
        'Standard Configuration': 'Standard Configuration',
        'New Configuration': 'New Configuration',
        'The values ​​defined in Standard Configuration correspond to the respective column and enum values ​​in the Template CSV. If you want to change these values, select another configuration option.':
            'The values ​​defined in Standard Configuration correspond to the respective column and enum values ​​in the Template CSV. If you want to change these values, select another configuration option.',
        'The values ​​defined on the left must not be changed. The values ​​on the right must be the same as the respective column and enum values ​​in the CSV file.':
            'The values ​​defined on the left must not be changed. The values ​​on the right must be the same as the respective column and enum values ​​in the CSV file.',
        'Import Configuration Name': 'Import Configuration Name',
        'Define a name for the new config...': 'Define a name for the new config...',
        'A file with this name already exists. Enter a different name or click the Save button to overwrite it.':
            'A file with this name already exists. Enter a different name or click the Save button to overwrite it.',
        Save: 'Save',
        'Upload CSV': 'Upload CSV',
        'Download CSV template': 'Download CSV template',
        'The CSV must use a semicolon (;) as a delimiter between values.':
            'The CSV must use a semicolon (;) as a delimiter between values.',
        'Reviews required: ': 'Reviews required: ',
        'You must fix errors identified in the Import Configuration or CSV file, then confirm the data import.':
            'You must fix errors identified in the Import Configuration or CSV file, then confirm the data import.',
        'Confirm import data': 'Confirm import data',
        'Static Data Input File': 'Static Data Input File',
        'Invalid enum value': 'Invalid enum value',
        'Invalid attribute': 'Invalid attribute',
        New: 'New',
        wells: 'wells',
        interventionKey: 'interventions',
        sections: 'sections',
        section: 'section',
        'rig tables': 'rig tables',
        'rig table': 'rig table',
        runs: 'runs',
        run: 'run',
        'cement plugs': 'cement plugs',
        'tubulars type': 'tubulars type',
        'restricted pipe movements': 'restricted pipe movements',
        'restricted pipe movement': 'restricted pipe movement',
        'restricted connections': 'restricted connections',
        'restricted connection': 'restricted connection',
        'restricted rops': 'restricted rops',
        'restricted rop': 'restricted rop',
        'Well Name': 'Well Name',
        'Well ID': 'Well ID',
        'Reference System': 'Reference System',
        Tactic: 'Tactic',
        startKey: 'Start',
        End: 'End',
        'Status Reason': 'Status Reason',
        'Tubular Interval Per Time': 'Tubular Interval Per Time',
        'Extend Last Tubular': 'Extend Last Tubular',
        'Tubular Connection Type': 'Tubular Connection Type',
        'Permanent Tubular Installation': 'Permanent Tubular Installation',
        'Restricted Pipe Movement Type': 'Restricted Pipe Movement Type',
        'Restricted Movement Goal': 'Restricted Movement Goal',
        'Restriction Type': 'Restriction Type',
        'Restricted Connection Goal': 'Restricted Connection Goal',
        'Restricted ROP': 'Restricted ROP',
        'Restricted ROP Goal': 'Restricted ROP Goal',
        'Error Validation': 'Error Validation',
        'Local errors detected': 'Local errors detected',
        'Hierarchy errors detected': 'Hierarchy errors detected',
        'There are some errors that you need to fix before proceeding with the transfer.':
            'There are some errors that you need to fix before proceeding with the transfer.',
        errorKey: 'error',
        errorsKey: 'errors',
        found: 'found',
        'must be resolved': 'must be resolved',
        About: 'About',
        'Error transferring the entities': 'Error transferring the entities',
        'Error validating the entities': 'Error validating the entities',
        'Error validating the fields': 'Error validating the fields',
        'An error occurred when importing the data': 'An error occurred when importing the data',
        'Unable to save config': 'Unable to save configuration',
        'The data was successfully transferred to Static Data Dashboard.':
            'The data was successfully transferred to Static Data Dashboard.',
        'All validations are ok!': 'All validations are ok!',
        'The data is ready to be transferred': 'The data is ready to be transferred',
        'It was not possible to validate': 'It was not possible to validate',
        'You need to select some entity': 'You need to select some entity',
        'Draft table': 'Draft table',
        draftQuestionMessage: 'Now that the data has been successfully transferred, ',
        draftBoldQuestionMessage: 'what do you want to do with the static data draft table?',
        'Discard the draft table': 'Discard the draft table',
        'Keep the draft table': 'Keep the draft table',
        'Data has been imported successfully': 'Data has been imported successfully',
        'Import Configuration has been saved successfully': 'Import Configuration has been saved successfully',
        'Import Configuration has been updated successfully': 'Import Configuration has been updated successfully',
        'There must be a well.': 'There must be a well.',
        'There must be exactly one well.': 'There must be exactly one well.',
        'Unable to get codaf well': 'Unable to get codaf well',
        'Unable to get codaf rig': 'Unable to get codaf rig',
        'Checklist for Intervention': 'Checklist for Intervention',
        'Collapse all': 'Collapse all',
        'Expand all': 'Expand all',
        'Associated rigs will have RPI calculations grouped into a single table.':
            'Associated rigs will have RPI calculations grouped into a single table.',
        'RPI calculation is done per Relevant Path by default, but you can change to Non-Relevant Path or both for all individual or associated rigs.':
            'RPI calculation is done per Relevant Path by default, but you can change to Non-Relevant Path or both for all individual or associated rigs.',
        'RPI Path': 'RPI Path',
        'RPI Calculation Settings': 'RPI Calculation Settings',
        'Rigs Association': 'Rigs Association',
        'Main Table': 'Main Table',
        'Auxiliary Table': 'Auxiliary Table',
        Join: 'Join',
        Detach: 'Detach',
        'New Rigs Association': 'New Rigs Association',
        'No options available': 'No options available',
        'Expand all': 'Expand all',
        'Transfer to KPI Static Data': 'Transfer to KPI Static Data',
        'Confirm transfer': 'Confirm transfer',
        'Permission Required': 'Permission Required',
        "You don't have the necessary permissions": "You don't have the necessary permissions",
        'TUBULARS INTERVAL': 'TUBULARS INTERVAL',
        'Per depth': 'Per depth',
        'Per time': 'Per time',
        'Cemented Plug': 'Cemented Plug',
        'importer.well': 'well',
        'importer.section': 'section',
        'importer.rigTable': 'rig table',
        'importer.run': 'run',
        'importer.intervention': 'intervention',
        'importer.tubular': 'tubular',
        'importer.pipeMovement': 'pipe movement',
        'importer.connection': 'connection',
        'importer.rop': 'rop',
        'importer.cement': 'cement',
        ...performanceWidgetEn
    }
}
